import * as type from './type'

export const feedbackHelper = {
  type,
}
